import { createRequest } from '@savgroup-front-common/core/services/request';

export const GET_LOANS = createRequest('GET_LOANS');
